import {AbstractControl, FormArray, FormGroup} from '@angular/forms';

export class ReactiveFormUtils {
  public static updateChildrenValueAndValidity(control: AbstractControl, options: {emitEvent: boolean} = {emitEvent: true}): void {
    if (control.enabled) {
      if (control instanceof FormGroup || control instanceof FormArray) {
        Object.values(control.controls).forEach((childControl: AbstractControl) => this.updateChildrenValueAndValidity(childControl));
      } else {
        control.updateValueAndValidity({onlySelf: true, emitEvent: options.emitEvent});
      }
    }
  }

  public static markAllEnabledAsTouched(control: AbstractControl): void {
    if (control.enabled) {
      control.markAsTouched({onlySelf: true});

      if (control instanceof FormGroup || control instanceof FormArray) {
        Object.values(control.controls).forEach((childControl: AbstractControl) => this.markAllEnabledAsTouched(childControl));
      }
    }
  }
}
